import { useState } from "react"
import { useCustomerTenantQuery } from "@/v2-backoffice-client/customer/tenant/customer.tenant.query"
import CustomerTenantTable, {
  type CustomerTenantTableProps,
} from "@/v2-backoffice-client/customer/tenant/CustomerTenantTable"

export type CustomerTenantProps = Omit<
  CustomerTenantTableProps,
  | "customerId"
  | "customerName"
  | "tenants"
  | "onRefresh"
  | "isLoading"
  | "error"
  | "onDeletedFilterChange"
> & {
  customerId: number
  customerName: string
  externalCustomerId?: string
}

function CustomerTenant(props: CustomerTenantProps) {
  const {
    customerId,
    customerName,
    externalCustomerId,
    ...customerTenantTableProps
  } = props

  const [onlyDeleted, setOnlyDeleted] = useState<boolean | undefined>(false)

  const { data, loading, error, refetch } = useCustomerTenantQuery({
    variables: { customerId, onlyDeleted },
  })

  const tenants = data?.getCustomerTenants || []

  return (
    <CustomerTenantTable
      customerId={customerId}
      customerName={customerName}
      externalCustomerId={externalCustomerId}
      tenants={tenants}
      isLoading={loading}
      error={error}
      onDeletedFilterChange={setOnlyDeleted}
      onRefresh={refetch}
      {...customerTenantTableProps}
    />
  )
}

export default CustomerTenant
